import React from "react";
import { useReducedMotion } from "framer-motion";
import { KineticBackground } from "@/components/KineticBackground";
import { HERO_VIDEO, HERO_VIDEO_POSTER } from "@/content";

// Renders the hero backdrop behind the centred logo.
// If a movement film URL is set in content.js (HERO_VIDEO), it plays that film
// with a soft royal-blue wash for contrast. Otherwise it falls back to the
// built-in animated "movement lettering" field so the hero always looks intentional.
export function HeroBackground({ dense = false }) {
  const reduce = useReducedMotion();
  const video = HERO_VIDEO && HERO_VIDEO.trim();

  if (!video) return <KineticBackground dense={dense} />;

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
      {reduce ? (
        HERO_VIDEO_POSTER ? (
          <img src={HERO_VIDEO_POSTER} alt="" className="h-full w-full object-cover" />
        ) : <div className="h-full w-full bg-ink-800" />
      ) : (
        <video
          className="h-full w-full object-cover"
          autoPlay muted loop playsInline
          poster={HERO_VIDEO_POSTER || undefined}
        >
          <source src={video} />
        </video>
      )}
      {/* Legibility wash + brand light so the white logo reads over any footage */}
      <div className="absolute inset-0 bg-ink-900/55" />
      <div className="absolute inset-0 bg-gradient-to-t from-ink-900 via-ink-900/30 to-ink-900/40" />
      {/* Kinetic curved lines + movement lettering layered ON TOP of the film */}
      <KineticBackground dense={dense} />
    </div>
  );
}

export default HeroBackground;
